export function transformSoftwareMeter(meter) {
  return {
    id: meter.id,
    name: meter.name,
    agentIds: meter.agentIds,
    description: meter.description,
    disabled: meter.disabled,
    startTime: meter.startTime,
    stopTime: meter.stopTime,
    canDelete: meter.deleteableOob,
    canEdit: meter.updatebleOob,
  }
}

export function transformSoftwareMeterForServer(meter) {
  return {
    name: meter.name,
    agentIds: meter.agentIds,
    // refId: meter.refId,
    description: meter.description,
  }
}
